"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagSelectionState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var services_1 = require("../services");
var store_1 = require("../store");
var tag_sort_state_1 = require("./tag.sort.state");
var TagSelectionState = /** @class */ (function () {
    function TagSelectionState(pageState) {
        var _this = this;
        /**
         * Selected collections by tag.
         *
         * Tag fully selected:
         *     tagId => true
         *
         * Tag partially selected:
         *     tagId => collectionUUID => boolean
         */
        this.selectedByTag = mobx_1.observable.map({}, { deep: false });
        this.visibleTagListObjectIDs = [];
        this.expandedCollectionsUUIDs = [];
        this.lastSelectedTagIndex = -1;
        this.lastSelectedCollectionIndex = -1;
        this.pageState = pageState;
        (0, mobx_1.reaction)(function (_) { return _this.pageState.isCtrlShiftPressed; }, function (isCtrlShiftPressed) {
            if (!isCtrlShiftPressed) {
                _this.resetLastSelectedTagIndex();
                _this.resetLastSelectedCollectionIndex();
            }
        });
        this.reset();
    }
    TagSelectionState.prototype.reset = function () {
        this.selectedByTag.clear();
    };
    TagSelectionState.prototype.selectTag = function (tagId, selected) {
        var _this = this;
        if (selected === void 0) { selected = true; }
        var currentTagIndex = this.visibleTagListObjectIDs.indexOf(tagId);
        if (!this.pageState.isCtrlShiftPressed) {
            if (selected) {
                this.selectedByTag.set(tagId, true);
            }
            else {
                this.selectedByTag.delete(tagId);
            }
        }
        else {
            if (selected) {
                this.selectedByTag.set(tagId, true);
            }
            if (this.lastSelectedTagIndex !== -1 && this.lastSelectedTagIndex !== currentTagIndex) {
                this.findFromRange(this.visibleTagListObjectIDs, this.lastSelectedTagIndex, currentTagIndex, function (tagIdInRange) {
                    _this.selectedByTag.set(tagIdInRange, true);
                });
            }
        }
        if (selected) {
            this.lastSelectedTagIndex = currentTagIndex;
        }
        var tagSummary = store_1.AppStore.TagSummary.get(tagId);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Select', "Tag:".concat(selected ? 'On' : 'Off'), tagSummary.revisions.length);
    };
    TagSelectionState.prototype.selectAll = function (tags, selected) {
        if (selected === void 0) { selected = true; }
        for (var _i = 0, tags_1 = tags; _i < tags_1.length; _i++) {
            var tag = tags_1[_i];
            if (selected) {
                this.selectedByTag.set(tag.objectId, true);
            }
            else {
                this.selectedByTag.delete(tag.objectId);
            }
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Select', "EveryTag:".concat(selected ? 'On' : 'Off'), tags.length);
    };
    TagSelectionState.prototype.setExpandedCollectionsUUIDs = function (collectionUUIDs) {
        this.expandedCollectionsUUIDs = collectionUUIDs;
    };
    TagSelectionState.prototype.resetLastSelectedCollectionIndex = function () {
        this.lastSelectedCollectionIndex = -1;
    };
    TagSelectionState.prototype.resetLastSelectedTagIndex = function () {
        this.lastSelectedTagIndex = -1;
    };
    TagSelectionState.prototype.setVisibleTagListObjectIDs = function (tagListUUIDs) {
        this.visibleTagListObjectIDs = tagListUUIDs;
    };
    TagSelectionState.prototype.selectCollection = function (tagId, collectionUUID, selected) {
        if (selected === void 0) { selected = true; }
        var selectedCollections = this.getExpandedTagCollections(tagId);
        var currentCollectionIndex = this.expandedCollectionsUUIDs.indexOf(collectionUUID);
        this.selectedByTag.set(tagId, selectedCollections);
        if (!this.pageState.isCtrlShiftPressed) {
            if (selected) {
                selectedCollections.set(collectionUUID, selected);
            }
            else {
                selectedCollections.delete(collectionUUID);
                if (selectedCollections.size === 0) {
                    this.selectedByTag.delete(tagId);
                }
            }
        }
        else {
            if (selected) {
                selectedCollections.set(collectionUUID, selected);
            }
            if (this.lastSelectedCollectionIndex !== -1 && this.lastSelectedCollectionIndex !== currentCollectionIndex) {
                this.findFromRange(this.expandedCollectionsUUIDs, this.lastSelectedCollectionIndex, currentCollectionIndex, function (collectionUUIDInRange) {
                    selectedCollections.set(collectionUUIDInRange, selected);
                });
            }
        }
        if (selected) {
            this.lastSelectedCollectionIndex = currentCollectionIndex;
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Select', "Collection:".concat(selected ? 'On' : 'Off'));
    };
    TagSelectionState.prototype.isTagSelected = function (tagId) {
        return this.selectedByTag.has(tagId);
    };
    TagSelectionState.prototype.isCollectionSelected = function (tagId, collectionUUID) {
        var selectedCollections = this.selectedByTag.get(tagId);
        if (selectedCollections == null) {
            return false;
        }
        return selectedCollections === true || selectedCollections.has(collectionUUID);
    };
    TagSelectionState.prototype.collectionsSelectedSize = function (tagId) {
        var selectedCollections = this.selectedByTag.get(tagId);
        if (selectedCollections == null) {
            return 0;
        }
        if (selectedCollections === true) {
            var tagSummary = store_1.AppStore.TagSummary.get(tagId);
            return tagSummary.revisions.length;
        }
        return selectedCollections.size;
    };
    Object.defineProperty(TagSelectionState.prototype, "tagSize", {
        get: function () {
            return this.selectedByTag.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagSelectionState.prototype, "collectionSize", {
        get: function () {
            var size = 0;
            for (var _i = 0, _a = Array.from(this.selectedByTag.keys()); _i < _a.length; _i++) {
                var tagId = _a[_i];
                var selectedCollections = this.selectedByTag.get(tagId);
                if (selectedCollections === true) {
                    var tagSummary = store_1.AppStore.TagSummary.get(tagId);
                    size += tagSummary.revisions.length;
                }
                else {
                    size += selectedCollections.size;
                }
            }
            return size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagSelectionState.prototype, "collections", {
        get: function () {
            var collectionSummaries = [];
            for (var _i = 0, _a = this.tags; _i < _a.length; _i++) {
                var tagId = _a[_i];
                for (var _b = 0, _c = this.getCollectionUUIDs(tagId); _b < _c.length; _b++) {
                    var collectionUUID = _c[_b];
                    var collectionSummary = store_1.AppStore.CollectionSummary.getFetchableByUuid(collectionUUID).value;
                    if (collectionSummary != null) {
                        collectionSummaries.push(collectionSummary);
                    }
                }
            }
            return tag_sort_state_1.TagSortState.sortSummaries(collectionSummaries);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagSelectionState.prototype, "ready", {
        get: function () {
            var ready = true;
            // Attempt to load all tags and collection summaries
            var tagIds = Array.from(this.selectedByTag.keys());
            for (var _i = 0, tagIds_1 = tagIds; _i < tagIds_1.length; _i++) {
                var tagId = tagIds_1[_i];
                ready = store_1.AppStore.Tag.get(tagId) != null && ready;
                for (var _a = 0, _b = this.getCollectionUUIDs(tagId); _a < _b.length; _a++) {
                    var collectionUUID = _b[_a];
                    ready = store_1.AppStore.CollectionSummary.getFetchableByUuid(collectionUUID).value != null && ready;
                }
            }
            return ready;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagSelectionState.prototype, "tags", {
        get: function () {
            var tags = Array.from(this.selectedByTag.keys())
                .map(function (tagId) { return store_1.AppStore.Tag.get(tagId); });
            return tag_sort_state_1.TagSortState.sortTags(tags)
                .map(function (tag) { return tag.objectId; });
        },
        enumerable: false,
        configurable: true
    });
    TagSelectionState.prototype.getExpandedTagCollections = function (tagId) {
        var expandedCollections = mobx_1.observable.map();
        var selectedCollections = this.selectedByTag.get(tagId);
        if (selectedCollections == null) {
            return expandedCollections;
        }
        if (selectedCollections === true) {
            var tagSummary = store_1.AppStore.TagSummary.get(tagId);
            for (var _i = 0, _a = tagSummary.revisions; _i < _a.length; _i++) {
                var revision = _a[_i];
                var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
                if (collectionSummary != null) {
                    expandedCollections.set(collectionSummary.uuid, true);
                }
            }
            return expandedCollections;
        }
        return selectedCollections;
    };
    TagSelectionState.prototype.getCollectionUUIDs = function (tagId) {
        var selectedCollections = this.selectedByTag.get(tagId);
        if (selectedCollections === null) {
            return [];
        }
        if (selectedCollections === true) {
            return Array.from(this.getExpandedTagCollections(tagId).keys());
        }
        return Array.from(selectedCollections.keys());
    };
    TagSelectionState.prototype.findFromRange = function (items, startIndex, endIndex, callback) {
        var start = Math.min(startIndex, endIndex);
        var end = Math.max(startIndex, endIndex);
        for (var i = start; i <= end; i++) {
            callback(items[i]);
        }
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], TagSelectionState.prototype, "visibleTagListObjectIDs", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TagSelectionState.prototype, "expandedCollectionsUUIDs", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TagSelectionState.prototype, "lastSelectedTagIndex", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TagSelectionState.prototype, "lastSelectedCollectionIndex", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], TagSelectionState.prototype, "selectTag", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagSelectionState.prototype, "selectAll", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagSelectionState.prototype, "setExpandedCollectionsUUIDs", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagSelectionState.prototype, "resetLastSelectedCollectionIndex", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagSelectionState.prototype, "resetLastSelectedTagIndex", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagSelectionState.prototype, "setVisibleTagListObjectIDs", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagSelectionState.prototype, "selectCollection", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagSelectionState.prototype, "collectionSize", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagSelectionState.prototype, "collections", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagSelectionState.prototype, "ready", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagSelectionState.prototype, "tags", null);
    return TagSelectionState;
}());
exports.TagSelectionState = TagSelectionState;
//# sourceMappingURL=tag.selection.state.js.map